import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import { GetStoreByID, EditStoreApi } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { showErrorToast, showSuccessToast } from "../../components/ToastMesg";
import DoubleField from "../../components/DoubleField";
import TextInputField from "../../components/TextInputField";
import TextAreaField from "../../components/TextAreaField";

const EditStore = () => {
  let param = useParams();
  const navigate = useNavigate();
  const { currentColor } = useStateContext();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    tax: "0",
    // manager: "select",
    street_address: "",
    city: "",
    state: "",
    postal_code: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate("/Stores");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleUpdateClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoading(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoading(false);
      return;
    }
    try {
      const response = await EditStoreApi(
        param.Store_id,
        formData.name,
        formData.email,
        formData.phone,
        null,
        formData.street_address,
        formData.city,
        formData.state,
        formData.postal_code,
        formData.tax,
      );
      if (response.status) {
        showSuccessToast("Success!", "Store updated successfully!");
      } else
        showErrorToast(
          "Error!",
          "Store failed to update!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Store failed to update!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (param.Store_id) {
        await GetStoreByID(param.Store_id)
          .then((result) => {
            setFormData({
              name: result.data.name || "",
              email: result.data.email || "",
              phone: result.data.contact || "",
              tax: result.data.tax || "0",
              street_address: result.data.street_address || "",
              city: result.data.city || "",
              state: result.data.state || "",
              postal_code: result.data.postal_code || "",
              manager: result.data.manager || "select",
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [param.Store_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="EDIT STORE" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>GENERAL INFORMATION</b>
                </div>
                <TextInputField
                  label="Name:"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  compulsory={true}
                  error={errors.name}
                />
                <TextInputField
                  label="Email:"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  compulsory={true}
                  error={errors.email}
                />
                <TextInputField
                  label="Phone:"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone"
                  compulsory={true}
                  error={errors.phone}
                />
                <DoubleField
                  label="Tax %:"
                  name="tax"
                  value={formData.tax}
                  onChange={handleChange}
                  placeholder="Tax"
                  min="0"
                  compulsory={true}
                  error={errors.tax}
                />
              </div>
            </Col>
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>LOCATION DETAIL</b>
                </div>
                <TextAreaField
                  label="Street Address:"
                  name="street_address"
                  value={formData.street_address}
                  onChange={handleChange}
                  placeholder="Street Address"
                  error={errors.street_address}
                />
                <TextInputField
                  label="City:"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="City"
                  compulsory={true}
                  error={errors.city}
                />
                <TextInputField
                  label="State:"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  placeholder="State"
                  error={errors.state}
                />
                <TextInputField
                  label="Postal Code:"
                  name="postal_code"
                  value={formData.postal_code}
                  onChange={handleChange}
                  placeholder="Postal Code"
                  error={errors.postal_code}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleUpdateClick}
          disabled={loading}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditStore;
